<template>
  <v-sheet v-if="isInstallButtonVisible" color="primary" elevation="4" class="pwa-banner rounded-b-lg">
    <v-avatar rounded="lg" size="26" class="bg-white flex-shrink-0">
      <v-img src="/pwa/icon-192.png" alt="" cover />
    </v-avatar>
    <p class="pwa-banner__text text-white">{{ $t("install ILearnQuran app on your device?") }}</p>
    <v-btn variant="text" color="on-primary" size="small" density="comfortable" @click="dismiss">
      {{ $t("installDismiss") }}
    </v-btn>
    <v-btn variant="flat" color="white" size="small" density="comfortable" class="text-primary font-weight-bold"
      rounded="pill" @click="installApp">
      {{ $t("installConfirm") }}
    </v-btn>
  </v-sheet>
</template>
<script>
let deferredPrompt;
export default {
  name: "PwaInstallButton",
  data() {
    return {
      isInstallButtonVisible: false,
    };
  },
  created() {
    window.addEventListener("appinstalled", () => {
      this.isInstallButtonVisible = false;
    });
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      deferredPrompt = e;
      this.isInstallButtonVisible = true;
    });
  },
  methods: {
    dismiss() {
      this.isInstallButtonVisible = false;
    },
    installApp() {
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        deferredPrompt = null;
      });
      this.isInstallButtonVisible = false;
    },
  },
};
</script>
<style scoped>
.pwa-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: calc(env(safe-area-inset-top, 0px) + 8px) 12px 8px;
  margin-bottom: 10px;
}

.pwa-banner__text {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 13px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
